import { all, takeLatest, takeEvery, call, put } from 'redux-saga/effects';
import { ENDPOINT_CATEGORIAS } from '~/config/constants';
import { Types, loadCategoriasSuccess, loadCategoriasFailure } from './actions';
import { Types as TypesIndicacao } from '../indicacao/actions';
import api from '../../../config/axios';

export function* loadSetup() {
  try {
    const response = yield call(api.get, ENDPOINT_CATEGORIAS);
    yield put(loadCategoriasSuccess(response.data));
  } catch (e) {
    yield put(loadCategoriasFailure());
  }
}

export default all([
  takeLatest(Types.REQUEST, loadSetup),
  takeEvery(TypesIndicacao.SEARCH_CNPJ, loadSetup),
  takeEvery(TypesIndicacao.SEARCH_ENDERECO, loadSetup),
]);
